
export enum FieldType {
  Text = "text",
  Email = "email",
  Tel = "tel",
  Number = "number",
  Textarea = "textarea",
  Select = "select",
  Checkbox = "checkbox",
  Radio = "radio",
  // Date = "date",
  // Time = "time",
  // DateTime = "datetime",
  // Color = "color",
  File = "file",
  // Image = "image",
  Hidden = "hidden",
  Password = "password",
  RouterSelect = "select-router",
}
